import {useNavigate} from 'react-router-dom';
import {useBreadcrumbs, usePageHeaderContent} from '@/hooks/useBreadcrumbs';
import Icon, {ICONS} from 'patient-ping-remedy/packages/icon';
import {BackButton, BreadcrumbLink, HeaderContentSlot, Title, Wrapper} from '@common/pages/PageHeader.styles';

export default function PageHeader() {
  const breadcrumbs = useBreadcrumbs();
  const headerContent = usePageHeaderContent();
  const navigate = useNavigate();

  if (breadcrumbs.length === 0) return null;

  const ancestors = breadcrumbs.slice(0, -1);
  const current = breadcrumbs[breadcrumbs.length - 1];

  return (
    <Wrapper>
      {ancestors.length > 0 && (
        <BackButton type="button" aria-label="Go back" onClick={() => navigate(ancestors[ancestors.length - 1].path)}>
          <Icon iconClass={ICONS['arrow-left']} weight="far" style={{height: '1.8rem', width: '1.8rem'}} />
        </BackButton>
      )}
      {ancestors.map((crumb) => (
        <span key={crumb.path}>
          <BreadcrumbLink onClick={() => navigate(crumb.path)}>
            {crumb.label}
            <Icon iconClass={ICONS['angle-right']} weight="far" iconSize="lg" />
          </BreadcrumbLink>
        </span>
      ))}
      <Title>{current.label}</Title>
      {headerContent && <HeaderContentSlot>{headerContent}</HeaderContentSlot>}
    </Wrapper>
  );
}
